module.exports = __webpack_public_path__ + "static/media/CustomerSites_v1.2.5ea6a42e.xlsx";